<div *ngIf="currentState === State.CHOOSE_SETTING">
  <mat-list id="settings-list">
    <mat-list-item
      *ngIf="showForwarding"
      (click)="changeState(State.FORWARDING); selectedFwdSettingsCategory = FWD_SETTINGS_CATEGORY.BUSINESS"
    >
      <mat-icon matListIcon>phone_forwarded</mat-icon>
      <h4 matLine>{{ 'user_settings.forwarding' | translate }}</h4>
      <p matLine class="subheader">{{ 'user_settings.forwarding_descr' | translate }}</p>
    </mat-list-item>
    <mat-divider *ngIf="showForwarding"></mat-divider>
    <mat-list-item (click)="changeState(State.DISPLAY_NUMBER)">
      <mat-icon matListIcon>dialpad</mat-icon>
      <h4 matLine>{{ 'user_settings.display_number' | translate }}</h4>
      <p matLine class="subheader">{{ 'user_settings.display_number_descr' | translate }}</p>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item (click)="changeState(State.WORKING_HOURS)">
      <mat-icon matListIcon>access_time</mat-icon>
      <h4 matLine>{{ 'user_settings.working_hours' | translate }}</h4>
      <p matLine class="subheader">{{ 'user_settings.working_hours_descr' | translate }}</p>
    </mat-list-item>
    <mat-divider *ngIf="showStatus"></mat-divider>
    <mat-list-item *ngIf="showStatus" (click)="changeState(State.SELECT_STATUS)">
      <mat-icon matListIcon>event</mat-icon>
      <h4 matLine>{{ 'user_settings.status_settings' | translate }}</h4>
      <p matLine class="subheader">{{ 'user_settings.status_settings_descr' | translate }}</p>
    </mat-list-item>
    <mat-divider *ngIf="showAdvancedSettings"></mat-divider>
    <mat-list-item *ngIf="showAdvancedSettings" (click)="changeState(State.ADVANCED)">
      <mat-icon matListIcon>settings</mat-icon>
      <h4 matLine>{{ 'user_settings.advanced' | translate }}</h4>
      <p matLine class="subheader">{{ 'user_settings.advanced_descr' | translate }}</p>
    </mat-list-item>
  </mat-list>
</div>

<div *ngIf="currentState === State.DISPLAY_NUMBER" fxLayout="column" fxLayoutGap="16px">
  <gt-display-number-settings [login]="login" [oname]="orgname" [canEdit]="canEdit" [fullNumber]="fullNumber"></gt-display-number-settings>
  <button mat-raised-button (click)="changeState(State.CHOOSE_SETTING)" i18n="@@Back button text" color="primary">
    {{ 'global.back' | translate }}
  </button>
</div>

<div *ngIf="currentState === State.SELECT_STATUS" fxLayout="column" fxLayoutGap="16px">
  <mat-list>
    <ng-container *ngFor="let status of absenceReasons$ | async; let last = last">
      <button [id]="'status' + status.reasonId" class="listButton" mat-button (click)="changeSelectedStatus(status)">
        <img height="24" alt="tick" [src]="status.img" />
        {{ status.message }}
      </button>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>
  </mat-list>
  <button mat-raised-button (click)="changeState(State.CHOOSE_SETTING)" i18n="@@Back button text" color="primary">
    {{ 'global.back' | translate }}
  </button>
</div>

<div *ngIf="currentState === State.ADVANCED" fxLayout="column" fxLayoutGap="16px">
  <mat-list>
    <button (click)="changeState(State.BLACKLIST)" class="listButton" mat-button>
      {{ 'user_settings.blacklist' | translate }}
    </button>
    <mat-divider></mat-divider>
    <button (click)="changeState(State.PRIORITIZED_NUMBERS)" class="listButton" mat-button>
      {{ 'user_settings.prioritized_numbers' | translate }}
    </button>
    <ng-container *ngIf="showEWSSync">
      <mat-divider></mat-divider>
      <button (click)="changeState(State.EWS_SYNC)" class="listButton" mat-button>
        {{ 'user_settings.ews_sync' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="showTwinning && hasTwinningNum">
      <mat-divider></mat-divider>
      <button (click)="changeState(State.TWINNING_SETTINGS)" class="listButton" mat-button>
        {{ 'twinning.settings' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="isAdministrator && showBlockOutgoing">
      <mat-divider></mat-divider>
      <button (click)="changeState(State.OUTGOING_CALLS)" class="listButton" mat-button>
        {{ 'user_settings.outgoing_calls' | translate }}
      </button>
    </ng-container>
  </mat-list>
  <button mat-raised-button (click)="changeState(State.CHOOSE_SETTING)" color="primary">
    {{ 'global.back' | translate }}
  </button>
</div>

<div *ngIf="currentState === State.CHOOSE_FORWARDING_SETTINGS" fxLayout="column" fxLayoutGap="16px">
  <mat-list>
    <button
      (click)="changeState(State.FORWARDING); selectedFwdSettingsCategory = FWD_SETTINGS_CATEGORY.BUSINESS"
      class="listButton"
      mat-button
    >
      {{ 'user_settings.forwarding_business' | translate }}
    </button>
    <mat-divider></mat-divider>
    <button
      (click)="changeState(State.FORWARDING); selectedFwdSettingsCategory = FWD_SETTINGS_CATEGORY.OUT_OF_OFFICE"
      class="listButton"
      mat-button
    >
      {{ 'user_settings.forwarding_ooo' | translate }}
    </button>
    <mat-divider></mat-divider>
    <button
      (click)="changeState(State.FORWARDING); selectedFwdSettingsCategory = FWD_SETTINGS_CATEGORY.PRIVATE"
      class="listButton"
      mat-button
    >
      {{ 'user_settings.forwarding_private' | translate }}
    </button>
  </mat-list>
  <button mat-raised-button (click)="changeState(State.CHOOSE_SETTING)" color="primary">
    {{ 'global.back' | translate }}
  </button>
</div>

<gt-working-hours *ngIf="currentState === State.WORKING_HOURS" [login]="login" [oname]="orgname" [canEdit]="canEdit"> </gt-working-hours>

<div *ngIf="currentState === State.BLACKLIST">
  <gt-blacklist [listType]="nameValueListTypes.BLACKLIST_INCOMING" [login]="login" [oname]="orgname" [canEdit]="canEdit"></gt-blacklist>
</div>

<div *ngIf="currentState === State.PRIORITIZED_NUMBERS">
  <gt-whitelist [listType]="nameValueListTypes.ABSENCE_WHITELIST" [login]="login" [orgId]="orgname" [canEdit]="canEdit"></gt-whitelist>
</div>

<div *ngIf="currentState === State.EWS_SYNC">
  <gt-ews-sync-settings [login]="login" [oname]="orgname" [canEdit]="canEdit"></gt-ews-sync-settings>
</div>

<gt-twinning-settings
  *ngIf="currentState === State.TWINNING_SETTINGS"
  [login]="login"
  [oname]="orgname"
  [canEdit]="canEdit"
></gt-twinning-settings>

<div *ngIf="currentState === State.OUTGOING_CALLS && isAdministrator" fxLayout="column" fxLayoutGap="16px">
  <gt-blacklist [listType]="nameValueListTypes.BLACKLIST_OUTGOING" [login]="login" [oname]="orgname" [canEdit]="canEdit"></gt-blacklist>
  <gt-whitelist [listType]="nameValueListTypes.WHITELIST_OUTGOING" [login]="login" [orgId]="orgname" [canEdit]="canEdit"></gt-whitelist>
  <button mat-raised-button (click)="changeState(State.ADVANCED)" color="primary">
    {{ 'global.back' | translate }}
  </button>
</div>

<gt-forwarding-settings-status-available
  *ngIf="statusAvailable && currentState === State.FORWARDING"
  [status]="statusAvailable"
  [settingsCategory]="selectedFwdSettingsCategory"
  (backObservable)="changeState(State.CHOOSE_SETTING)"
  [login]="login"
  [orgname]="orgname"
  [canEdit]="canEdit"
>
</gt-forwarding-settings-status-available>

<gt-status-settings
  *ngIf="selectedStatus && currentState === State.STATUS_SETTINGS"
  [status]="selectedStatus"
  (backObservable)="changeState(State.SELECT_STATUS)"
>
</gt-status-settings>

<div fxLayout="column" fxLayoutGap="16px">
  <div></div>
  <button mat-raised-button fxFill *ngIf="currentState === State.WORKING_HOURS" (click)="changeState(State.CHOOSE_SETTING)" color="primary">
    {{ 'global.back' | translate }}
  </button>

  <button
    mat-raised-button
    fxFill
    *ngIf="
      currentState === State.BLACKLIST ||
      currentState === State.PRIORITIZED_NUMBERS ||
      currentState === State.TWINNING_SETTINGS ||
      currentState === State.EWS_SYNC
    "
    (click)="changeState(State.ADVANCED)"
    color="primary"
  >
    {{ 'global.back' | translate }}
  </button>
</div>
